const fetchAlert = state => state.alert;
const isMobileScreen = state => state.isMobileScreen;
const socketError = state => state.socketError;
const loadingMessage = state => state.loadingMessage;

export default {
  fetchAlert,
  isMobileScreen,
  socketError,
  loadingMessage
};
